import { connect } from "react-redux";
import { getBooks, ACTION_TYPES } from "../../../actions";
import LiteratureTab from "./components";

const mapStateToProps = (state) => ({
  filterActionType: ACTION_TYPES.LITERATURE_SEARCH_CRITERIA,
  getBooks: (params) => getBooks({ ...params, filterName: "literatureFilter" }),
  literatureBooks: state.books.literatureBooks,
  literatureLoading: state.books.literatureLoading,
  literatureLoaded: state.books.literatureLoaded,
  literatureError: state.books.literatureError,
});

export default connect(mapStateToProps)(LiteratureTab);
